import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Card, Tabs } from 'antd';
import { txt } from 'libs/i18n';
import Loading from 'components/Loading';
import { extractLanguagesFromProfiles, fetchTranscriptionProfiles, } from 'api/user-api';
import { useSession } from 'components/Authenticated';
import DashboardPage from '../../components/DashboardPage';
import AlertPage from '../AlertPage';
import RolesTab from './RolesTable';
import SpeakersTab from './SpeakersTab';
const SpeakersPage = () => {
    const [locales, setLocales] = useState('loading');
    const { session } = useSession();
    const fetchLocales = async () => {
        const profilesResult = await fetchTranscriptionProfiles(session.connection);
        if (profilesResult.isFail()) {
            setLocales('error');
            return;
        }
        const profiles = profilesResult.get();
        const availableLanguages = extractLanguagesFromProfiles(profiles);
        setLocales(availableLanguages);
    };
    useEffect(() => {
        void fetchLocales();
    }, []);
    if (locales === 'loading') {
        return (_jsx(DashboardPage, { title: txt('speakers'), children: _jsx(Loading, {}) }));
    }
    if (locales === 'error') {
        return (_jsx(AlertPage, { title: txt('error'), header: txt('error'), children: _jsx("p", { children: txt('noTranscriptionOptions') }) }));
    }
    return (_jsx(DashboardPage, { title: txt('speakers'), children: ({ contentHeight }) => (_jsx(Card, { bordered: false, children: _jsx(Tabs, { defaultActiveKey: "speakers", items: [
                    {
                        key: 'speakers',
                        label: txt('speakers'),
                        children: _jsx(SpeakersTab, { locales: locales, contentHeight: contentHeight }),
                    },
                    {
                        key: 'roles',
                        label: txt('roles'),
                        children: _jsx(RolesTab, { contentHeight: contentHeight }),
                    },
                ] }) })) }));
};
export default SpeakersPage;
